import {
    LayoutContext,
    LayoutContextReturnType,
} from 'components/Layout/context';
import {useContext} from 'react';

const useLayout = (): LayoutContextReturnType => {
    const context = useContext(LayoutContext);
    if (!context)
        return {
            classNameLabel: undefined,
            layout: 'stacked',
        };
    return context;
};

export default useLayout;
